export const ofertaSectionKeys = [
    "distribuicao",
    "linkSre",
    "situacaoDistribuicao",
    "situacaoOferta",
    "tipoRito",
    "bookbuilding",
    "remuneracaoBookbuilding",
    "regimeDistribuicao",
    "tipoMercado",
    "investidorGeralInicial",
    "investidorGeralFinal",
    "investidorQualificadoInicial",
    "investidorQualificadoFinal",
    "investidorProfissionalInicial",
    "investidorProfissionalFinal",
    "dataRequerimento",
    "dataRegistro",
    "dataInicioOferta",
    "dataEncerramentoMax",
    "dataEncerramentoEfetivo",
    "dataInicioReserva",
    "dataEncerramentoReserva",
    "dataBookbuilding",
    "dataLockupIGparaIG",
    "dataLockupIGparaIQ",
    "dataLockupIGparaIP",
    "dataLockupIQparaIG",
    "dataLockupIQparaIQ",
    "dataLockupIQparaIP",
    "dataLockupIPparaIG",
    "dataLockupIPparaIQ",
    "dataLockupIPparaIP",
    "coord1",
    "coord2",
    "coord3",
    "coord4",
    "coord5",
    "coord6",
    "coord7",
]
